module.exports = __webpack_public_path__ + "img/new.07dae6d5.svg";